import { PageInfo, Pagination } from "./index"

export const pageInfoFromPagination = (pagination: Pagination): PageInfo => {
  return {
    limit: pagination.limit,
    offset: pagination.offset,
    totalRecords: pagination.total_records,
    totalPages: pagination.total_pages,
    current: pagination.current_page,
  }
}
